module.exports = "<div class=\"mt-5 mb-5 text-center\">\r\n    <h1 class=\"titulo text-center mb-5\">Esperando la siguiente pregunta.</h1>\r\n</div> "